import { REDUCER_NAME } from './const'
import { selectCustomerDetailState as selectParentState } from '../selector'

export const selectOwnState = (state) => {
    return selectParentState(state)[REDUCER_NAME]
}

export const selectCommentText = state => {
    return selectOwnState(state).commentText
}

export const selectIsInternal = state => {
    return selectOwnState(state).isInternal
}

export const selectProcessInstanceList = state => {
    return selectOwnState(state).processList
}



// WEBPACK FOOTER //
// ./src/modules/customer/state/detail/tab-comments/selector.js